export default{
    与我们联系:"Contact Us Below ",
    专属客户经理将尽快联系您:"",
    立即参与:"Submit",
}